import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {convertPipeToBrTag} from '../../utils';

/**
 * 関連動画 `RelatedVideo`
 * - click で YouTube iframe.src を変更するのは使用側で行う
 * - `.RelatedVideo` に設定されている `data-yt` を取得します
 */
export default class RelatedVideo extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcTitle: PropTypes.string,
    mbTitle: PropTypes.string,
    pcDescription: PropTypes.string,
    mbDescription: PropTypes.string,
    youtubeId: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcTitle: null,
    mbTitle: null,
    pcDescription: null,
    mbDescription: null,
    youtubeId: null,
  };
  
  /**
   * `div.RelatedVideo__[pcTitle|mbTitle]` 作成します
   * @param {?string} title title text - {@link convertPipeToBrTag} します
   * @param {string} [suffix=''] [pcTitle|mbTitle]
   * @param {string} [alternate=''] title 不正値時の置換え文字
   * @param {string} [baseClass=RelatedVideo] class name 接頭詞
   * @returns {*} `div.RelatedVideo__[pcTitle|mbTitle]`
   */
  static titleTag(title, suffix = '', alternate = '', baseClass = 'RelatedVideo') {
    const text = (title !== null && title) ? title: alternate;
    if (text === null || !text) {
      return null;
    }
    // class name
    const className = `${baseClass}${(suffix) ? '__': ''}${suffix}`;
    // ReactElement
    return (
      <div className={className} dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/>
    );
  }
  
  /**
   * `div.RelatedVideo__[pcDescription|mbDescription]` 作成します
   * @param {?string} title description text - {@link convertPipeToBrTag} します
   * @param {string} [suffix=''] [pcTitle|mbTitle]
   * @param {string} [alternate=''] title 不正値時の置換え文字
   * @param {string} [baseClass=RelatedVideo] class name 接頭詞
   * @returns {*} `div.RelatedVideo__[pcDescription|mbDescription]`
   */
  static descriptionTag(title, suffix = '', alternate = '', baseClass = 'RelatedVideo') {
    const text = (title !== null && title) ? title: alternate;
    if (text === null || !text) {
      return null;
    }
    // class name
    const className = `${baseClass}${(suffix) ? '__': ''}${suffix}`;
    // ReactElement
    return (
      <div className={className} dangerouslySetInnerHTML={{__html: convertPipeToBrTag(text)}}/>
    );
  }
  
  // constructor(props) {
  //     super(props);
  //     // ---
  //     // const youtubeId = props.youtubeId || '';
  //     // const path = youtubeId ? `//img.youtube.com/vi/${youtubeId}/maxresdefault.jpg` : '';
  //     // /**
  //     //  * React.state
  //     //  * - path - thumbnail path
  //     //  * @type {{path: string}}
  //     //  */
  //     // this.state = {
  //     //     path,
  //     // };
  // }
  /**
   * description を作成します - {@link RelatedVideo}.titleTag
   * @returns {?ReactElement} `div.RelatedVideo__descriptions`
   */
  renderDescriptions() {
    const {
      pcDescription,
      mbDescription,
    } = this.props;
    const alternate = pcDescription || '';
    const pc = RelatedVideo.descriptionTag(pcDescription, 'pcDescription');
    const mb = RelatedVideo.descriptionTag(mbDescription, 'mbDescription', alternate);
    if (!pc && !mb) {
      return null;
    }
    // output
    return (
      <div className="RelatedVideo__descriptions">
        {pc}
        {mb}
      </div>
    );
  }
  
  /**
   * description を作成します - {@link RelatedVideo}.descriptionTag
   * @returns {?ReactElement} `div.RelatedVideo__titles`
   */
  renderTitles() {
    const {
      pcTitle,
      mbTitle,
    } = this.props;
    const alternate = pcTitle || '';
    const pc = RelatedVideo.titleTag(pcTitle, 'pcTitle');
    const mb = RelatedVideo.titleTag(mbTitle, 'mbTitle', alternate);
    if (!pc && !mb) {
      return null;
    }
    // output
    return (
      <div className="RelatedVideo__titles">
        {pc}
        {mb}
      </div>
    );
  }
  
  /**
   * YouTube thumbnail `//img.youtube.com/vi/YOUTUBE_ID/maxresdefault.jpg`
   * @returns {?ReactElement} `div.RelatedVideo__thumb__block`
   */
  renderThumbnail() {
    const {youtubeId} = this.props;
    const attributes = {
      className: 'RelatedVideo__thumb',
    };
    if (youtubeId) {
      const path = `//img.youtube.com/vi/${youtubeId}/maxresdefault.jpg`;
      attributes.style = {backgroundImage: `url(${path})`};
    }
    return (
      <div className="RelatedVideo__thumb__block">
        <div {...attributes} />
      </div>
    );
  }
  
  /**
   * `div.RelatedVideo`
   * - {@link RelatedVideo.renderDescriptions}
   * - {@link RelatedVideo.renderTitles}
   * - {@link RelatedVideo.renderThumbnail}
   * @returns {?ReactElement} `div.RelatedVideo`
   */
  render() {
    const {
      containerId,
      containerClass,
      youtubeId,
    } = this.props;
    // require check
    // YouTube ID 不正の場合は出力しない
    if (!youtubeId) {
      return null;
    }
    // title
    const title = this.renderTitles();
    const description = this.renderDescriptions();
    // thumbnail
    return (
      <div
        className="RelatedVideo"
        data-yt={youtubeId}
      >
        <Wrapper
          containerId={containerId}
          containerClass={containerClass}
        >
          <div className="RelatedVideo__link" onTouchStart={(e)=>{}}>
            {
              this.renderThumbnail()
            }
            <div className="RelatedVideo__text">
              {title}
              {description}
            </div>
          </div>
        </Wrapper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/related-video/index.jsx